import rankingScoreIndex from "../views/ranking-score/ranking-score-index";
import jobIndex from "../views/job/task-index.vue";
import improperAccessCheckingService from "../services/improperAccessCheckingService";
import Constants from "../constants";

export default [
  {
    path: "/app/:userDeptRoleId/job/received",
    component: jobIndex,
    name: "job-index",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC_DUOCGIAO)
    }
  },
  {
    path: "/app/:userDeptRoleId/job/received/detail/:id",
    name: "detail-job",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC_DUOCGIAO)
    }
  },

  {
    path: "/app/:userDeptRoleId/job/assigned",
    component: jobIndex,
    name: "job-index-assigned",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC_GIAO)
    }
  },

  {
    path: "/app/:userDeptRoleId/job/assigned/detail/:id",
    name: "detail-job-assigned",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC_GIAO)
    }
  },

  {
    path: "/app/:userDeptRoleId/job/sub_detail/:id",
    name: "sub-detail-job",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC)
    }
  },

  {
    path: "/app/:userDeptRoleId/job/dept_assigned",
    component: jobIndex,
    name: "job-index-dept-assigned",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC_DONVI)
    }
  },
  {
    path: "/app/:userDeptRoleId/job/dept_assigned/detail/:id",
    name: "detail-job-dept-assigned",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC_DONVI)
    }
  },

  {
    path: "/app/:userDeptRoleId/job/coordinate",
    component: jobIndex,
    name: "job-index-coordinate",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC_LIENQUAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/job/coordinate/detail/:id",
    name: "detail-job-coordinate",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC_LIENQUAN)
    }
  },

  {
    path: "/app/:userDeptRoleId/rankingScoreIndex",
    component: rankingScoreIndex,
    name: "rankingScoreIndex",
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.CONGVIEC_SCORE)
    }
  },

  {
    path: "/app/:userDeptRoleId/job/all",
    component: jobIndex,
    name: "job-index-all"
  },

  {
    path: "/app/:userDeptRoleId/job/all/detail/:id",
    name: "detail-job-all",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/job.js